import React, { useContext } from 'react';

import { GlobalComponentsContext } from 'context/GlobalComponentsContext';

import leankeepLogo from 'assets/icons/leankeep/leankeep-facility-logo.svg';
import mobileLogo from 'assets/icons/leankeep/logotipo.svg';
import MobileSymbol from 'assets/icons/leankeep/símbolo_LKP.svg';
import HamburgerIcon from 'assets/icons/leankeep/menu-hambuguer.svg';

import {
  StyledBackgroundEffect,
  StyledMenuMobile,
  StyledLogo,
  StyledMenuButton,
  StyledHamburguer,
  MobileLogoContainer,
  StyledLogoMobile,
  StyledSymbolMobile,
} from './styled';

import { MobileContainer } from 'components/Menu/MobileMenu/styled';
import { UserCircle } from 'lucide-react';
import { UserIcon } from 'components/Menu/UserMenu/styled';
import { MobileMenu } from 'components/Menu/MobileMenu';
import { AuthContext } from 'context';

const MobileNavbar = () => {
  const { globalComponentsContext, setGlobalComponentsContext } = useContext(GlobalComponentsContext);

  const { authContext } = useContext(AuthContext);
  const { user } = authContext;

  const { isMobileMenuOpen, isMobileProfileOpen } = globalComponentsContext;

  const handleMobileMenuOpen = () =>
    setGlobalComponentsContext(prevState => ({
      ...prevState,
      isMobileMenuOpen: !isMobileMenuOpen,
    }));

  const handleMobileProfileOpen = () =>
    setGlobalComponentsContext(prevState => ({
      ...prevState,
      isMobileProfileOpen: !isMobileProfileOpen,
    }));

  return (
    <>
      <StyledMenuMobile>
        <StyledMenuButton theme="white" size="small" onClick={handleMobileMenuOpen}>
          <StyledHamburguer src={HamburgerIcon} alt="Menu" onClick={handleMobileMenuOpen} />
          Menu
        </StyledMenuButton>

        <StyledLogo src={leankeepLogo} alt="Leankeep" />

        <MobileLogoContainer>
          <StyledLogoMobile src={mobileLogo} alt="Leankeep" />
          <StyledSymbolMobile src={MobileSymbol} alt="Leankeep" />
        </MobileLogoContainer>

        <MobileContainer onClick={handleMobileProfileOpen}>
          <UserCircle>
            <span>{user?.name || ''}</span>
            <UserIcon size={18} />
          </UserCircle>
          <MobileMenu />
        </MobileContainer>
      </StyledMenuMobile>

      <StyledBackgroundEffect isActive={isMobileMenuOpen} onClick={handleMobileMenuOpen} />
    </>
  );
};

export { MobileNavbar };
